import styled from 'styled-components';
import { black, white, grey200, greenLight } from 'styles/colors';

export const Wrapper = styled.div`
	border: ${props =>
		props.checked ? `2px solid ${greenLight}` : `1px solid ${grey200}`};
	border-radius: 1px;
	background-color: ${white};
	box-shadow: 0 4px 13px 0 rgba(0, 0, 0, 0.05);
	margin-top: 20px;
	padding: 30px, 0;
`;

export const Title = styled.h3`
	color: ${black};
	font-size: 16px;
	font-weight: bold;
	letter-spacing: 0.3px;
	line-height: 24px;
	margin-top: 10px;
`;

export const Description = styled.p`
	color: #737373;
	font-size: 13px;
	letter-spacing: 0.8px;
	line-height: 19px;
	margin: 0px 30px 20px 50px;
`;
